var _defs, _circle, _path, _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHitzebestaendigBis300GradC = function SvgHitzebestaendigBis300GradC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Hitzebestaendig_bis_300GradC_svg__Ebene_2",
    viewBox: "0 0 75.26 101.91"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Hitzebestaendig_bis_300GradC_svg__cls-4{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.2px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Hitzebestaendig_bis_300GradC_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.09 39.06c-4.62 0-9.1-.72-13.3-2.13a39.8 39.8 0 0 1-9.52-4.69c-5.05-3.39-7.65-6.83-7.67-6.86l-1.26-1.71-1.26 1.71s-2.62 3.48-7.67 6.87a40 40 0 0 1-9.52 4.69c-4.2 1.41-8.68 2.13-13.3 2.13H0v13.28c0 7 .91 13.44 2.69 19.25.28.91.58 1.8.91 2.68.46 1.27.96 2.51 1.51 3.71 2.73 5.9 6.54 10.98 11.32 15.08a44.2 44.2 0 0 0 11.33 7.03c3.09 1.3 5.17 1.74 5.26 1.76l.32.06.32-.06c.09-.02 2.17-.45 5.26-1.76 2.82-1.19 7.07-3.38 11.33-7.03 4.78-4.1 8.59-9.17 11.32-15.08.5-1.07.94-2.18 1.37-3.3.33-.88.65-1.77.93-2.68 1.86-5.91 2.81-12.49 2.81-19.66V39.07h-1.57Zm-4.95 34.06c-.43 1.18-.89 2.34-1.4 3.45-2.52 5.48-6.03 10.19-10.44 14a41 41 0 0 1-10.49 6.56c-2.18.93-3.82 1.39-4.48 1.55-.66-.17-2.31-.62-4.48-1.55a40.8 40.8 0 0 1-10.49-6.56c-4.41-3.81-7.92-8.52-10.44-14-.56-1.22-1.05-2.49-1.51-3.78-.31-.88-.61-1.78-.88-2.7-1.57-5.36-2.38-11.29-2.38-17.75V42.18c4.44-.15 8.74-.92 12.82-2.29a42.9 42.9 0 0 0 10.3-5.11c3.4-2.29 5.75-4.59 7.07-6.03 1.32 1.44 3.67 3.73 7.07 6.03a43.2 43.2 0 0 0 10.3 5.11c4.07 1.38 8.38 2.15 12.82 2.29v10.16c0 6.59-.84 12.63-2.48 18.07q-.42 1.38-.9 2.7Z",
    style: {
      fill: "currentColor"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.56,
    cy: 17.71,
    r: 11.38,
    className: "Hitzebestaendig_bis_300GradC_svg__cls-4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.56 4.64V1.1M64.14 6.42l1.78-3.06M68.93 11.26 72 9.52M70.62 17.86l3.54.04M68.77 24.42l3.04 1.81M63.87 29.15l1.71 3.1M57.25 30.77l-.08 3.54M50.72 28.84l-1.86 3.02M46.04 23.89l-3.12 1.67M44.5 17.25l-3.54-.12M46.5 10.74l-2.99-1.89M51.51 6.12l-1.63-3.14",
    className: "Hitzebestaendig_bis_300GradC_svg__cls-4"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "currentColor",
      fontFamily: "ProximaNova-Bold,&quot",
      fontSize: "16.83px",
      fontWeight: 700
    },
    transform: "translate(8.69 66.62)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "300")), /*#__PURE__*/React.createElement("tspan", {
    x: 30.75,
    y: 0,
    style: {
      letterSpacing: "-.06em"
    }
  }), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 34.12,
    y: 0
  }, "\xB0C")))));
};
export default SvgHitzebestaendigBis300GradC;